// i18n area 'common' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.ro-RO.meta.json.
import type { enUS } from './common'

export const roRO: typeof enUS = {
  nav: {
    home: 'Acasă',
    vms: 'Mașini virtuale',
    templates: 'Template-uri',
    importVms: 'Importă VM-uri',
    containers: 'Containere',
    containersApps: 'Aplicații',
    containersPods: 'Poduri',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Imagini OCI',
    containersOciRegistries: 'Registry-uri OCI',
    containersCtTemplates: 'Template-uri CT',
    networkServices: 'Servicii de rețea',
    firewall: 'Firewall',
    checkpoints: 'Checkpointuri',
    backup: 'Backup',
    monitoring: 'Monitorizare',
    cluster: 'Cluster',
    clusterSettings: 'Setări globale',
    clusterNodes: 'Noduri',
    clusterDevices: 'Resurse USB și PCIe',
    clusterFederation: 'Federare',
    network: 'Rețea',
    overlayNetworks: 'Rețele overlay',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Date',
    storages: 'Storage',
    hci: 'Hiperconvergență',
    ceph: 'Ceph',
    system: 'Sistem',
    tasks: 'Taskuri',
    events: 'Evenimente',
    audit: 'Audit',
    diagnostics: 'Diagnosticare',
    notifications: 'Notificări',
    proximity: 'TVirt Proximity',
    users: 'Utilizatori și grupuri',
    groups: 'Grupuri',
    mfa: 'MFA',
    realms: 'Realmuri și SSO',
    rbac: 'Roluri și permisiuni',
    credentials: 'Credențiale',
    scopes: 'Scope-uri',
    tags: 'Taguri',
    explorer: 'Explorează',
    licensing: 'Licență',
    information: 'Informații'
  },
  mode: {
    light: 'Luminos',
    dark: 'Întunecat',
    system: 'Sistem',
    tooltip: 'Temă'
  },
  language: {
    tooltip: 'Limbă'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'America de Nord',
    southAmerica: 'America de Sud',
    asia: 'Asia'
  },
  notFound: {
    title: 'Pagina nu a fost găsită',
    body: 'Această adresă nu corespunde niciunei pagini TVirt — poate s-a mutat odată cu o actualizare sau linkul este vechi.',
    backHome: 'Înapoi la Acasă'
  },
  scopeBrowser: {
    title: 'Scope-uri',
    all: 'Întregul cluster',
    noChildren: 'Niciun sub-scope aici',
    recursive: 'Include descendenții',
    collapse: 'Restrânge panoul de scope-uri',
    openPicker: 'Explorează scope-urile',
    up: 'Un nivel mai sus',
    countTooltip: '{direct} în acest scope · {total} cu descendenții'
  },
  search: {
    tooltip: 'Caută (⌘K)',
    placeholder: 'Caută VM-uri, rețele, storage…',
    empty: 'Niciun rezultat',
    groups: {
      recent: 'Recente',
      shortcuts: 'Comenzi rapide',
      actions: 'Acțiuni',
      goTo: 'Mergi la'
    },
    kind: {
      catalog: 'Catalog',
      scope: 'Scope',
      node: 'Nod'
    },
    footer: {
      navigate: 'navighează',
      open: 'deschide',
      close: 'închide'
    },
    actions: {
      createVm: 'Creează VM…',
      uploadIso: 'Încarcă ISO…',
      clusterSettings: 'Setări cluster',
      consoleOf: 'Mergi la consola lui {name}'
    }
  },
  stub: {
    containersSummary: 'Aplicații și containere de sistem (CT), cu imaginile lor OCI, registry-urile și template-urile — gestionate alături de VM-urile tale.',
    sectionSummary_vms: 'Mașinile virtuale și template-urile lor — ciclu de viață, snapshoturi, migrare și console.',
    sectionSummary_storages: 'Storage-urile unde trăiesc discurile, imaginile și metadatele VM-urilor.',
    sectionSummary_catalogs: 'Casa artefactelor-fișier ale clusterului: imagini ISO, template-uri CT și VM și arhive OCI, organizate în cataloage.',
    sectionSummary_overlay: 'Rețele overlay VXLAN între nodurile clusterului.',
    sectionSummary_fabric: 'Inventarul rețelei fizice — switch-uri, porturi, LAGG-uri și rețele logice.',
    sectionSummary_ipam: 'Adresarea derivată din rețelele fabric și overlay: cine deține fiecare adresă.',
    sectionSummary_services: 'Servere DHCP și DNS derivate din registrul de rețea.',
    sectionSummary_ceph: 'Clusterele Ceph gestionate pe nodurile TVirt.',
    sectionSummary_hci: 'Tehnologiile de storage hiperconvergente pe nodurile TVirt.',
    sectionSummary_cluster: 'Noduri, apartenență și setări la nivel de cluster.',
    containers: 'Containerele de sistem sunt în roadmap — această secțiune le va găzdui.',
    containersApps: 'Aplicațiile containerizate sunt în roadmap — această zonă le va găzdui.',
    containersPods: 'Podurile grupează containere care partajează rețeaua și volumele — instanțele sunt aplicațiile.',
    containersCt: 'Containerele de sistem (CT) sunt în roadmap — această zonă le va găzdui.',
    multiscsi: 'TVStor MultiSCSI este în roadmap — această zonă îl va găzdui.',
    clusterFederation: 'Federarea între clustere TVirt este în roadmap — această zonă o va găzdui.',
    containersOciImages: 'Imaginile OCI sunt în roadmap — această zonă le va găzdui.',
    containersOciRegistries: 'Registry-urile OCI sunt în roadmap — această zonă le va găzdui.',
    containersCtTemplates: 'Template-urile CT sunt în roadmap — această zonă le va găzdui.',
    importVms: 'Importerele ESXi și Proxmox vor sosi aici: conversia guesturilor și migrarea în masă în TVirt.',
    backup: 'Backupul integrat sosește cu 6.2: repository-uri content-addressed deduplicate, incrementale CBT, ferestre de imutabilitate și replicare repo-to-repo.',
    monitoring: 'Dashboardurile de contenție la nivel de cluster (cpu.ready, presiune PSI, alerte integrate) sunt pe drum — azi aceleași metrici trăiesc în detaliile fiecărei VM.'
  },
  home: {
    welcome: 'Ești conectat cu contul: {name}',
    subtitle: 'Iată clusterul tău TVirt dintr-o privire.',
    loadError: 'Nu s-a putut încărca prezentarea generală — este backend-ul TVirt accesibil?',
    health: {
      ok: 'Totul în regulă',
      warning: 'Atenție',
      critical: 'Probleme critice'
    },
    reason: {
      'node-down': '{subject} este stins',
      'node-stale': '{subject} nu a mai dat semne de ceva vreme',
      'node-maintenance': '{subject} în mentenanță',
      'tasks-failed': {
        one: '{n} task eșuat în ultimele 24h',
        few: '{n} taskuri eșuate în ultimele 24h',
        other: '{n} de taskuri eșuate în ultimele 24h'
      },
      'storage-degraded': 'storage {subject} degradat',
      'storage-error': 'storage {subject} în eroare',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store-ul clusterului inaccesibil',
      'license-absent': 'nicio licență — VM-urile noi nu pot porni',
      'license-expired': 'licență expirată — VM-urile noi nu pot porni',
      'license-exceeded': 'limita licenței depășită — VM-urile noi nu pot porni',
      'failover-reserve-eroded': 'rezerva de failover aproape consumată',
      'failover-reserve-exhausted': 'rezerva de failover epuizată — VM-urile noi nu pot porni',
      'oci-cache-nearly-full': 'cache-ul OCI aproape plin pe {subject} — digesturile se evacuează manual',
      'oci-cache-full': 'cache-ul OCI plin pe {subject} — niciun pull nu va reuși până nu evacuezi digesturi',
      'config-replica-empty': 'replica de configurație GOALĂ pe {subject} — nodul nu are configurația clusterului până când o replicare nu reușește',
      'config-replica-stalled': 'replicarea configurației pe {subject} este blocată — copia locală rămâne în urma configurației clusterului'
    },
    staleChip: 'Date neactualizate',
    staleAsOf: 'ultima replicare {time}',
    zone: {
      nodes: 'Noduri',
      failoverReserve: 'Rezervă de failover',
      capacity: 'Capacitate',
      workload: 'Sarcină de lucru',
      protection: 'Protecție',
      activity: 'Activitate recentă'
    },
    reserve: {
      state: {
        ok: 'Rezervă intactă',
        eroded: 'Rezervă aproape consumată',
        exhausted: 'Rezervă epuizată',
        unknown: 'Rezervă necunoscută'
      },
      tolerate: {
        one: 'tolerează pierderea a {n} nod',
        few: 'tolerează pierderea a {n} noduri',
        other: 'tolerează pierderea a {n} de noduri'
      },
      usedOf: '{used} / {allowed} GiB în uz',
      keepFree: '{n} GiB păstrați liberi pentru failover',
      expendable: 'dintre care sacrificabili în exploatare: {n}',
      headroom: 'se mai pot porni {n} GiB',
      short: 'rezervei îi lipsesc {n} GiB — VM-urile noi nu pot porni',
      hp: {
        usedOf: 'Pagini de {size} — în uz: {used} / {allowed}',
        keepFree: 'păstrate libere pentru failover: {keep}',
        headroom: 'încă pornibile: {n}',
        short: 'lipsă din rezervă: {n} — VM-urile noi cu pagini uriașe nu pot porni'
      },
      worstCase: 'cazul cel mai rău: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Niciun nod nu și-a declarat încă memoria — rezerva nu poate fi calculată și nicio pornire nu este refuzată.',
      reason: {
        attestedDown: 'atestat stins',
        maintenance: 'în mentenanță',
        unreachable: 'inaccesibil',
        capacityUnknown: 'memorie nedeclarată'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: 'core-uri: {cores} / thread-uri: {threads}',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} VM activ',
        few: '{n} VM-uri active',
        other: '{n} de VM-uri active'
      },
      activeVmsUnknown: 'VM-uri active necunoscute',
      lastSeen: 'văzut {time}',
      neverSeen: 'niciodată văzut',
      down: 'Stins',
      maintenance: 'Mentenanță',
      stale: 'Inaccesibil'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provizionați',
      reserve: 'rezervă {n} GiB',
      unobserved: 'capacitate încă neobservată',
      empty: 'Niciun storage încă'
    },
    workload: {
      vms: 'Mașini virtuale',
      apps: 'Aplicații',
      services: 'Servicii de rețea',
      empty: 'Încă nimic',
      phasesUnknown: 'defalcarea pe faze nu este disponibilă'
    },
    protection: {
      none: 'Nicio destinație de backup configurată — protejează-ți configurația.',
      configure: 'Configurează checkpointurile',
      noRuns: 'Niciun checkpoint nu a fost creat încă.',
      last: 'Ultimul checkpoint',
      onTarget: 'pe {target}',
      viewAll: 'Checkpointuri'
    },
    activity: {
      empty: 'Nicio activitate recentă',
      failed24: {
        one: '{n} eșuat în 24h',
        few: '{n} eșuate în 24h',
        other: '{n} de eșuate în 24h'
      },
      viewAll: 'Vezi toate taskurile'
    }
  },
  notes: {
    title: 'Note',
    tabEdit: 'Modifică',
    tabPreview: 'Previzualizare',
    placeholder: 'Note libere ale operatorului — Markdownul este redat în previzualizare',
    empty: 'Nicio notă',
    tooLarge: 'Notele depășesc limita de 64 KiB',
    saveError: 'Nu s-au putut salva notele'
  },
  common: {
    contractError: 'Răspunsul backend-ului conține o valoare pe care această interfață nu o cunoaște: {field}={value} — actualizează interfața web la versiunea backend-ului.',
    contractErrorItems: '{count} dintre obiectele acestei liste nu pot fi citite de această interfață ({field}={value}) și nu sunt afișate.',
    staleHint: 'Store-ul este inaccesibil — se afișează replica de config a acestui nod; starea flotei este necunoscută.',
    staleStateAge: 'stare de {time}',
    staleStateNever: 'starea nu a fost niciodată primită din store: vezi doar observațiile acestui nod',
    staleStateTooltip: 'Store-ul clusterului este inaccesibil: starea observată (fază, nod, agent) provine din replica de stare a acestui nod și datează de la ultima citire reușită din store — poate fi învechită.',
    noPermission: 'Nu ai permisiunea pentru această acțiune',
    actionStillRunning: 'Acțiunea este încă în curs: rezultatul nu este încă cunoscut',
    staleWrite: 'Altcineva a modificat acest obiect în timp ce îl editați — nu s-a scris nimic. Reîncărcați și repetați modificarea pe starea actuală.',
    staleReload: 'Reîncarcă',
    preview: 'Previzualizare',
    previewTitle: 'Previzualizarea rezultatului',
    previewNothingWritten: 'Simulată pe server — nu s-a scris nimic.',
    previewChanged: 'Evidențiate: valorile care s-ar schimba.'
  },
  context: {
    copySelection: 'Copiază textul selectat'
  },
  crud: {
    create: 'Creează',
    viewDetails: 'Vezi detaliile',
    viewOrEdit: 'Vezi sau modifică',
    selected: 'selectate',
    viewUsingVms: 'Vezi VM-urile care folosesc resursa',
    clearSelection: 'Deselectează',
    deleteSelected: 'Șterge elementele selectate',
    bulkConfirmBody: {
      one: 'Ștergi elementul selectat ({count})? Dacă este protejat, va fi semnalat și păstrat.',
      few: 'Ștergi elementele selectate ({count})? Cele protejate vor fi semnalate și păstrate.',
      other: 'Ștergi elementele selectate ({count})? Cele protejate vor fi semnalate și păstrate.'
    },
    bulkDeleted: 'șterse',
    bulkRefused: 'refuzate',
    fieldId: 'ID',
    createdAt: 'Creat la',
    updatedAt: 'Actualizat la',
    immutableField: 'Fixat la creare — contractul nu permite modificarea lui',
    immutableScope: 'Scope-ul se atribuie la creare; unele resurse se mută printr-o acțiune dedicată',
    observedField: 'Stare observată — raportată de platformă, nemodificabilă'
  }
}
